import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import { HttpError, isError } from "../../state/helpers/Error"
import HttpClient from "../../state/helpers/HttpClient"
import { CardOnFile } from "../../state/listing/contact/models"
import { NewBankAccountOnFilePayload } from "../../state/payment/bankaccount/NewBankAccountOnFilePayload"
import PaymentMethod, { PaymentMethodDto } from "../model/paymentmethod"

export type CreditCard = {
    externalId: string
    cardHolderName: string
    brand: string
    country: string
    postalCode: string
    expirationMonth: number
    expirationYear: number
    fingerprintId: string
    last4: string
}

class PaymentMethodService {

    static httpClient: HttpClient<PaymentMethod, PaymentMethodDto> =
        new HttpClient<PaymentMethod, PaymentMethodDto>(PaymentMethod)

    static async createPaymentMethodConfig(contactID: string, merchantId: string, cardholderName?: string): Promise<PaymentMethod | HttpError> {
        const res = await this.httpClient.post("/rainforest/payment-method-configs", {
            contactID: contactID,
            cardholderName: cardholderName,
            merchantId: merchantId,
        })
        if (isError(res)) {
            return res as HttpError
        }
        return res as PaymentMethod
    }

    static async addCardOnFile(
        externalPaymentMethodId: string,
        fingerprintId: string,
        contactId: string,
        locationId: string
    ): Promise<CardOnFile | undefined> {
        const data = {
            fingerprintId: fingerprintId,
            creditCard: {
                saveCard: true,
                savedCardToken: externalPaymentMethodId,
            },
            locationId
        }
        const url = `/contacts/${contactId}/cards-on-file`
        const res = await AppContext.getApiClient().post(url, data)
        if (!res.error) {
            return res as CardOnFile
        }
        return undefined
    }

    static async addBankAccountOnFile(payload: NewBankAccountOnFilePayload): Promise<boolean> {
        const data = {
            savedBankAccountToken: payload.externalPaymentMethodId,
            last4: payload.last4,
            locationId : payload.locationId
        }

        const url = `/contacts/${payload.contactId}/bank-accounts-on-file`
        AppContext.getApiClient().post(url, data).then(res => {
            return !res.error
        })
        return false
    }

}

export default PaymentMethodService



// WEBPACK FOOTER //
// ./src/payment-account/service/paymentMethodService.ts